<template>
    <div class="hat-box">
        <div class="center-box">
            <div class="left-center-box">
                <div class="title">{{hatData.title}}</div>
                <h3 class="caption">{{hatData.caption}}<span class="showdown"
                        v-if='hatData.showdown'>{{hatData.showdown}}</span></h3>
                <div class="chinese-box" v-html='hatData.chinese'></div>
                <div class="english-box" v-html='hatData.english'></div>
                <!-- 行走的线 -->
                <div class="animetionLine"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Hat',
        props: {
            hatData: Object
        },
        data() {
            return {
            }
        }
    }
</script>
<style scoped>
    .hat-box {
        margin-top: 323px;
        width: 1129px;
        height: 655px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/b97dad81779309.5d09ccd58e688.jpg') no-repeat left bottom;
        background-size: 60% 70%;
        position: relative;
        background-attachment: fixed;
    }

    .center-box {
        position: absolute;
        height: 100%;
        width: 810px;
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: translate(944px, -197px);
    }

    /* 测试 */
    .left-center-box {
        max-width: 530px;
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: rgba(36, 136, 248, 1);
    }

    .caption {
        font-size: 42px;
        font-weight: bold;
        line-height: 32px;
        color: rgba(51, 51, 51, 1);
        margin: 23px 0 46px 0;
    }

    .showdown {
        font-size: 42px;
        font-weight: 400;
        color: #ffffff;
        -webkit-text-stroke: 1px rgba(112, 112, 112, 1);
        text-stroke: 1px rgba(112, 112, 112, 1);
        padding-left: 15px;
    }

    .chinese-box>>>p {
        font-size: 16px;
        font-weight: 400;
        color: rgba(112, 112, 112, 1);
        line-height: 28px;
    }

    .chinese-box>>>p:not(:first-child) {
        margin-top: 20px;
    }

    .english-box {
        margin-top: 38px;
    }

    .english-box>>>p {
        font-size: 14px;
        font-weight: 400;
        line-height: 30px;
        color: rgba(153, 153, 153, 1);
    }

    /* .showdown {
        font-size: 64px;
        font-weight: 400;
        line-height: 64px;
        color: #ffffff;
        -webkit-text-stroke: 2px rgba(112, 112, 112, 1);
        text-stroke: 2px rgba(112, 112, 112, 1);
        padding-left: 15px;
    } */

    .left-center-box::before {
        content: 'Blue  Whale';
        display: block;
        white-space: nowrap;
        position: absolute;
        font-size: 14px;
        font-weight: bold;
        color: rgba(229, 229, 229, 1);
        top: 90px;
        right: 30px;
        transform: rotate(90deg);
    }

    .animetionLine {
        width: 46px;
        height: 14px;
        position: absolute;
        top: 165px;
        right: 44px;
        transform: rotate(90deg);
        overflow: hidden;
        z-index: 3;
        /* background-color:red; */
    }

    .animetionLine::after {
        content: '';
        display: block;
        transform: rotate(90deg);
        width: 1px;
        height: 46px;
        background-color: #E5E5E5;
        position: absolute;
        top: -110%;
        right: 50%;
        animation: linearMotion 2.5s infinite;
    }

    @keyframes bottomToright {
        from {
            transform: translateX(0%);
        }

        to {
            transform: translateX(-100%);
        }
    }

    /* 线条运动 */
    @keyframes linearMotion {
        from {
            right: 150%;
        }

        to {
            right: -52%;
        }
    }

    @media(max-width: 995px){
        .left-center-box::before,.animetionLine {
        display: none;
    }
    }
    /* @media(max-width: 1023px) {
        .hat-box {
            margin-top: 0px;
            width: 100%;
            height: 1200px;
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/b97dad81779309.5d09ccd58e688.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
        }

        .center-box {
            position: absolute;
            left: 50%;
            top: 50%;
            height: 80%;
            width: 80%;
            background-color: rgba(229, 229, 229, .95);
            display: flex;
            justify-content: center;
            align-items: center;
            transform: translate(-50%, -50%);
        }

        .title {
            font-size: 50px;
            line-height: 137%;
        }

        .caption {
            font-size: 72px;
            line-height: 115%;
        }

        .left-center-box {
            max-width: 80%;
        }

        .chinese-box>>>p {
            font-size: 50px;
            line-height: 175%;
        }
    }
    @media(max-width: 355px){
        .hat-box {
            height: 1800px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/main/project/hat.vue